import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, Kicker } from "@/components/Reveal";

const BrandingFrame = () => {
  const { t } = useLanguage();
  const b = t.branding;
  const [open, setOpen] = useState(0);

  return (
    <section className="bg-olive text-cream py-24 md:py-36" data-testid="branding-frame">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5">
            <Reveal>
              <span className="font-mono text-[0.7rem] uppercase tracking-[0.28em] text-sand/80">
                {b.kicker}
              </span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif font-light text-4xl sm:text-5xl md:text-6xl leading-[1.05] mt-6">
                {b.headline}
              </h2>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="text-cream/75 font-light leading-relaxed mt-8 max-w-md">
                {b.subtext}
              </p>
            </Reveal>
            <Reveal delay={0.24}>
              <Link
                to="/contact"
                data-testid="branding-apply-cta"
                className="inline-block mt-10 text-xs uppercase tracking-[0.18em] text-charcoal bg-cream hover:bg-sand transition-colors duration-300 px-9 py-4"
              >
                {b.cta}
              </Link>
            </Reveal>
          </div>

          <div className="md:col-span-6 md:col-start-7 border-t border-cream/20">
            {b.packages.map((p, i) => {
              const isOpen = open === i;
              return (
                <div key={p.title} className="border-b border-cream/20">
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`branding-package-${i}`}
                    className="w-full flex items-center justify-between gap-6 py-7 text-left group"
                  >
                    <span className="flex items-baseline gap-5">
                      <span className="font-mono text-xs text-sand/70">{p.n}</span>
                      <span className={`font-serif text-3xl md:text-4xl transition-colors ${isOpen ? "text-cream" : "text-cream/85 group-hover:text-sand"}`}>
                        {p.title}
                      </span>
                    </span>
                    <span className="shrink-0 text-sand">
                      {isOpen ? <Minus size={20} /> : <Plus size={20} />}
                    </span>
                  </button>
                  <AnimatePresence initial={false}>
                    {isOpen && (
                      <motion.div
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                        className="overflow-hidden"
                      >
                        <p className="text-cream/75 font-light leading-relaxed pb-8 pl-10 max-w-xl">
                          {p.text}
                        </p>
                      </motion.div>
                    )}
                  </AnimatePresence>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandingFrame;
